import React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { ThemeProvider as StyledThemeProvider } from "styled-components";

import { getGlobalTheme } from "merchant-portal-theme/GlobalTheme";

export const ThemeProvider: React.FC<React.PropsWithChildren> = ({ children }) => {
	const theme = getGlobalTheme();

	return (
		<StyledThemeProvider theme={theme}>
			<MuiThemeProvider theme={theme}>
				<CssBaseline />
				{children}
			</MuiThemeProvider>
		</StyledThemeProvider>
	);
};

export default ThemeProvider;
